// extracted by mini-css-extract-plugin
export default {"nextButton":"nextButton_nextButton__Xm+8w","label":"nextButton_label__uo+Yk"};